__turbopack_context__.v({
  "banner": "styles-module__B382Gq__banner",
  "listItem": "styles-module__B382Gq__listItem",
  "loaderWrapper": "styles-module__B382Gq__loaderWrapper",
  "productGrid": "styles-module__B382Gq__productGrid",
});
